export default __webpack_public_path__ + "static/media/warning--kangaloo-crossing--g1.f937c5b4.png";